<template>
  <div
    v-if="
      $route.path != '/testhome' &&
      $route.path != '/ascension' &&
      $route.path != '/ascension/dungeon' &&
      $route.path != '/testbattle-pass' &&
      $route.path != '/testavatar' &&
      $route.path != '/testanime/kono-subarashii-sekai-ni-shukufuku-wo-3' &&
      $route.path != '/teststore' &&
      $route.path != '/testroom' &&
      $route.path != '/buy/binyl' &&
      $route.path != '/test'
    "
  >
    <div v-if="$route.path != '/maintenance'" class="progressbar">
      <div id="color" class="color"></div>
    </div>
    <!-- valorant -->
    <HeaderMenu v-if="$route.path != '/maintenance'" />
    <!-- <HeaderMenuTest v-if="$route.path != '/maintenance'" /> -->
    <div class="flex justify-center">
      <!-- valorant -->
      <div class="max-w-[1200px] w-full sm:mx-8 calc4rem">
        <!-- <div id="router"> -->
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </div>
    <HeaderBottomMenu
      v-if="
        $route.path != '/maintenance' &&
        $route.path != '/admin/tiktok' &&
        $route.path != '/admin/tiktok/character' &&
        $route.path != '/admin/tiktok/easy' &&
        $route.path != '/admin/tiktok/v2' &&
        $route.path != '/testhome' &&
        $route.path != '/ascension' &&
        $route.path != '/ascension/dungeon' &&
        $route.path != '/testbattle-pass' &&
        $route.path != '/testavatar' &&
        $route.path != '/testanime/kono-subarashii-sekai-ni-shukufuku-wo-3' &&
        $route.path != '/teststore' &&
        $route.path != '/testroom'
      "
    />
  </div>
  <div v-else>
    <div v-if="$route.path != '/maintenance'" class="progressbar opacity-0">
      <div id="color" class="color"></div>
    </div>
    <!-- valorant -->
    <!-- <HeaderMenu v-if="$route.path != '/maintenance'" /> -->
    <HeaderMenuTest v-if="$route.path != '/maintenance'" ref="headerRef" />
    <div class="flex justify-center">
      <!-- valorant -->
      <!-- <div class="max-w-[1200px] w-full sm:mx-8 calc4rem"> -->
      <div id="router">
        <router-view :key="$route.name"></router-view>
      </div>
    </div>
    <HeaderBottomMenu
      v-if="
        $route.path != '/maintenance' &&
        $route.path != '/admin/tiktok' &&
        $route.path != '/admin/tiktok/character' &&
        $route.path != '/admin/tiktok/easy' &&
        $route.path != '/admin/tiktok/v2' &&
        auth.user.role != 'admin'
      "
    />
  </div>
</template>

<script setup>
  // valorant
  import HeaderMenu from "./components/HeaderMenu.vue";
  import HeaderMenuTest from "./components/HeaderMenuTest.vue";
  import HeaderBottomMenu from "./components/HeaderBottomMenu.vue";
  import {useRoute} from "vue-router";
  import {ref, onMounted, watch, provide} from "vue";
  import {useAuthStore} from "@/stores/auth";
  const auth = useAuthStore();

  const route = useRoute();
  const headerRef = ref(null);
  provide("headerRef", headerRef);

  const updateHreflang = () => {
    const head = document.head;

    // Supprimer les anciennes balises hreflang
    document.querySelectorAll('link[rel="alternate"]').forEach(el => el.remove());

    // Définition des URL des versions linguistiques
    const baseUrl = "https://api.baranimes.com";
    const langUrls = {
      fr: `${baseUrl}/fr/`,
      en: `${baseUrl}/en/`,
    };

    // Ajouter les nouvelles balises hreflang
    Object.entries(langUrls).forEach(([lang, url]) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = lang;
      link.href = url;
      head.appendChild(link);
    });

    // Ajouter x-default
    const defaultLink = document.createElement("link");
    defaultLink.rel = "alternate";
    defaultLink.hreflang = "x-default";
    defaultLink.href = baseUrl;
    head.appendChild(defaultLink);
  };

  // Mettre à jour les balises à chaque changement de route
  onMounted(updateHreflang);
  watch(() => route.path, updateHreflang);
  onMounted(async () => {
    window.addEventListener("keydown", prevDefArrow);

    // window.addEventListener("resize", appHeight);
    // appHeight();
  });
  const prevDefArrow = e => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };
  // const appHeight = () => {
  //   const vh = window.innerHeight * 0.01;
  //   document.documentElement.style.setProperty("--vh", `${vh}px`);
  // };
</script>
<style>
  html.overscroll-behavior-y-none,
  html.overscroll-behavior-y-none body {
    overscroll-behavior-y: none;
  }
  /* valorant  */
  /* :root {
  --white: #ffffff;
  --black: #000000;
  --light-t1: #ccc4ed;
  --text-color-1: rgba(187, 177, 231, 0.62);
  --text-color-2: rgba(154, 119, 35, 1);
  --text-color-3: rgba(3, 140, 54, 1);
  --text-color-4: #a395df;
  --text-color-5: #9f91de;
  --text-color-6: #826dff;
  --text-color-7: #9a7723;
  --text-color-8: #eaa742;
  --text-color-9: #e9a742;
  --text-color-10: #c4893b;
  --text-color-11: #ffe0b7;
  --text-color-12: #dfa650;
  --text-color-13: #ffca79;
  --border-color-2: #6b5536;
  --text-color-14: #038c36;
  --text-color-15: #04bc49;
  --text-color-16: #01ab3f;
  --text-color-17: #d4ffe4;
}
.valo {
  font-family: "VALORANT";
}
.main {
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  font-style: normal;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: auto;
  color: var(--text-color-1);
}
#router {
  transition: all 0.2s, opacity 0.2s;
  width: 100vw;
  height: 100vh;
}
#router > div {
  transition: all 0.3s;
}
#router.active {
  scale: 8;
}
#router.scale {
  scale: 0.5;
  transition: 0s !important;
}
#router.test > div {
  opacity: 0;
  transition: all 0.2s;
}
#router.line {
  transition: all 0.4s;
  width: 33.333%;
  border: 5px solid var(--light-t1);
  background: var(--light-t1);
} */

  /* fin valorant  */

  /* .page-enter-active,
.page-leave-active {
  transition: all 0.2s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  transform: scale(1.1);
} */
  /* valorant */
  .prod body :not(.animeScroll)::-webkit-scrollbar {
    width: 15px;
  }

  .prod body :not(.animeScroll)::-webkit-scrollbar-track {
    background: transparant;
  }

  .prod body :not(.animeScroll)::-webkit-scrollbar-thumb {
    background: #008ca8;
    border-radius: 100px;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
  }
  /* html {
  overflow: hidden;
}
body::-webkit-scrollbar {
  width: 0px;
} */

  .prod body {
    /* background: #111827; */
    /* background-color: #222c48; */
    background-color: #020420;
    color: white;
    min-height: 100vh;
    /* background: url(/global/bg_avatar.png), #030712;
   */
    background-size: cover;
  }
  /* valorant */
  .prod body > div {
    min-height: 100vh;
    background: radial-gradient(
        66.5% 221.21% at 136.03% -61.44%,
        rgba(245, 79, 103, 0.4) 0%,
        rgba(161, 155, 217, 0) 92.09%
      ),
      radial-gradient(93.54% 126.91% at 29.15% -56.29%, rgb(0 140 168 / 70%) 0%, rgba(233, 69, 96, 0) 92.09%),
      radial-gradient(86.19% 101.84% at -17.13% -24.8%, rgb(0 140 168 / 70%) 0%, rgba(0, 162, 254, 0) 92.09%);
    background-attachment: fixed;
  }
  /* valorant */
  /* body {
  background: linear-gradient(45deg, #2fddde 0%, #4f53af 30%, #344673 65%, #1e3344 100%);
} */
  .prod .home-card {
    transition: 0.3s;
  }
  .prod .home-card:hover {
    box-shadow: 0px 15px 20px rgb(0 140 168 / 40%);
    transform: translateY(-7px);
  }
  .prod .button-reverse {
    background: linear-gradient(to right, #008ca8 0%, #00fddc 50%, #008ca8 100%) !important;
    background-position: left center;
    transition: 0.4s;
    background-size: 200% auto !important;
  }
  .prod .button-reverse:hover {
    background-position: right center !important;
  }
  .prod .shadow-3xl {
    box-shadow: 0 4px 8px 2px rgba(0, 5, 13, 0.5);
  }
  .prod body .scrollbar-none {
    scrollbar-width: none;
  }
  .prod body .scrollbar-none::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: 639px) {
    .prod .calc2rem {
      width: calc(100% - 2rem) !important;
    }
  }
  @media (min-width: 640px) {
    .prod .sm\:shadow-3xl {
      box-shadow: 0 4px 8px 2px rgba(0, 5, 13, 0.5);
    }
    .prod .calc4rem {
      width: calc(100% - 4rem) !important;
    }
  }
  @media (min-width: 768px) {
    .prod .md\:shadow-3xl {
      box-shadow: 0 4px 8px 2px rgba(0, 5, 13, 0.5);
    }
  }
  .prod .bg-first {
    background: #020420 !important;
  }
  .prod .bg-second {
    background-color: #0f112b;
  }
  .prod .bg-linear {
    background: linear-gradient(to right, #008ca8 0%, #00fddc 100%);
  }
  .prod .bg-third {
    background-color: rgb(255 255 255 / 5%);
  }
  .prod .v-tooltip > .v-overlay__content {
    background-color: #0f112b;
    box-shadow: 0 4px 8px 2px rgba(0, 5, 13, 0.5);
  }
  .prod .v-skeleton-loader__image {
    height: 100%;
  }
  .prod .selected {
    background: #1c1e33;
  }
  .prod .font-medium {
    font-weight: 600 !important;
  }
  .prod .v-img__placeholder .v-sheet {
    background: #020420;
  }
  .prod .shadow-base {
    box-shadow: -5px -5px 5px -5px #008ca8, 5px 5px 5px -5px #008ca8, -7px -7px 10px -5px transparent,
      7px 7px 10px -5px transparent, 0 0 5px 0px rgba(255, 255, 255, 0), 0 55px 35px -20px rgba(0, 0, 0, 0.5);
    filter: drop-shadow(black 2px 4px 6px);
    padding: 3px 5px 0;
  }
  .prod .menu-anime {
    height: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 300ms;
    cursor: pointer;
    border-radius: 9999px;
    min-width: 46px;
  }
  .prod .menu-anime .line1,
  .prod .menu-anime .line2 {
    width: 16px;
    height: 2px;
    position: absolute;
    background: white;
    border-radius: 9999px;
  }
  .prod .menu-anime .line2 {
    rotate: 90deg;
  }
  .prod .modal-menu-anime button.active {
    box-shadow: #fff 0 0 16px 0;
    outline: 1px solid;
  }
  .prod .progressbar {
    position: fixed;
    top: 0px;
    width: 100%;
    z-index: 10001;
  }

  .prod .progressbar .color {
    animation: ease 1.5s normal;
    border-radius: 100px;
    background: #008ca8;
    height: 3px;
    transition: all 1.5s, visibility 0s;
    width: 0;
    transition-timing-function: ease;
  }

  /* valorant  */
  :root {
    --white: #ffffff;
    --black: #000000;
    --light-t1: #ccc4ed;
    --text-color-1: #c7cef8;
    --text-color-2: rgba(154, 119, 35, 1);
    --text-color-3: rgba(3, 140, 54, 1);
    --text-color-4: #a395df;
    --text-color-5: #9f91de;
    --text-color-6: #826dff;
    --text-color-7: #9a7723;
    --text-color-8: #eaa742;
    --text-color-9: #e9a742;
    --text-color-10: #c4893b;
    --text-color-11: #ffe0b7;
    --text-color-12: #dfa650;
    --text-color-13: #ffca79;
    --border-color-2: #6b5536;
    --text-color-14: #038c36;
    --text-color-15: #04bc49;
    --text-color-16: #01ab3f;
    --text-color-17: #d4ffe4;
    --v-theme-error: #f54f67;
  }
  html::-webkit-scrollbar {
    width: 0px;
  }
  html {
    scrollbar-width: none; /* Firefox */
  }

  /* html.dev {
    height: 100vh;
  } */
  .dev .main {
    font-size: 12px;
    line-height: 18px;
    font-weight: 500;
    font-style: normal;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: auto;
    color: var(--text-color-1);
  }
  .dev #router {
    transition: all 0.2s, opacity 150ms, scale 0.3s;
    width: 100vw;
    /* height: 100vh; */
  }
  .dev #router > div {
    transition: all 0.2s, opacity 150ms, scale 0.15s;
  }
  .dev #router.active {
    scale: 8;
  }
  .dev #router.scale {
    scale: 0.5;
    transition: 0s !important;
  }
  .dev #router.active2 {
    scale: 0.5;
  }
  .dev #router.scale2 {
    scale: 8;
    transition: 0s !important;
  }
  body.maxHeight {
    max-height: 100vh;
    overflow: hidden;
  }
  .dev #router.translateNegativeY {
    transform: translateY(-50%);
  }
  .dev #router.translateY {
    transform: translateY(50%);
  }
  .dev #router.translateYsecond {
    transition: 0s !important;
    transform: translateY(50%);
  }
  .dev #router.translateYthird {
    transition: 0s !important;
    transform: translateY(-50%);
  }
  .dev #router.test > div {
    opacity: 0;
    transition: all 0.2s, opacity 150ms, scale 0.15s;
  }
  .dev #router.line {
    transition: all 0.4s;
    width: 33.333%;
    border: 5px solid var(--light-t1);
    background: var(--light-t1);
  }

  /* fin valorant  */

  /* .page-enter-active,
  .page-leave-active {
    transition: all 0.2s;
  }
  .page-enter-from,
  .page-leave-to {
    opacity: 0;
    transform: scale(1.1);
  } */
  /* valorant */
  /* body :not(.animeScroll)::-webkit-scrollbar {
    width: 15px;
  }

  body :not(.animeScroll)::-webkit-scrollbar-track {
    background: transparant;
  }

  body :not(.animeScroll)::-webkit-scrollbar-thumb {
    background: #008ca8;
    border-radius: 100px;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
  } */
  /* html {
    overflow: hidden;
  }
  body::-webkit-scrollbar {
    width: 0px;
  } */

  .dev body {
    /* background: #111827; */
    /* background-color: #222c48; */
    background-color: #020420;
    color: white;
    min-height: 100vh;
    /* background: url(/global/bg_avatar.png), #030712;
     */
    background-size: cover;
  }
  /* valorant */
  /* body > div {
    min-height: 100vh;
    background: radial-gradient(
        66.5% 221.21% at 136.03% -61.44%,
        rgba(245, 79, 103, 0.4) 0%,
        rgba(161, 155, 217, 0) 92.09%
      ),
      radial-gradient(93.54% 126.91% at 29.15% -56.29%, rgb(0 140 168 / 70%) 0%, rgba(233, 69, 96, 0) 92.09%),
      radial-gradient(86.19% 101.84% at -17.13% -24.8%, rgb(0 140 168 / 70%) 0%, rgba(0, 162, 254, 0) 92.09%);
    background-attachment: fixed;
  } */
  /* valorant */
  .dev body {
    /* background: linear-gradient(45deg, #2fddde 0%, #4f53af 30%, #344673 65%, #1e3344 100%); */
    background: linear-gradient(45deg, #2fddde 0%, #4f53af 30%, #344673 65%, #223255 100%);
    background-attachment: fixed;
    transition: 0.3s;
  }
  .dev .bg-radiant {
    background: linear-gradient(45deg, #2fddde 0%, #4f53af 30%, #344673 65%, #223255 100%);
  }
  .dev body.ascension {
    /* background: url(https://api.baranimes.com/images/ascension/bg/sky.jpg),
      linear-gradient(351deg, #f01907 0%, #730036 30%, #452180 65%, #02085e 100%); */
    background: url(https://api.baranimes.com/images/ascension/bg1.png);
    background-size: cover;
    /* backdrop-filter: blur(4px); */
    background-position: center;
  }
  .dev body.dungeon {
    /* background: url(https://static.vecteezy.com/system/resources/previews/021/493/331/non_2x/hell-landscape-infernal-stone-cave-cartoon-free-vector.jpg),
      linear-gradient(347deg, #f07807 0%, #ffaf00 30%, #b10000 65%, #802121 100%); */
    background: url(https://api.baranimes.com/images/ascension/bg6.png);

    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    /* backdrop-filter: blur(0px); */
  }
  .dev .home-card {
    transition: 0.3s;
  }
  .dev .home-card:hover {
    box-shadow: 0px 15px 20px rgb(0 140 168 / 40%);
    transform: translateY(-7px);
  }
  .dev .button-reverse {
    background: linear-gradient(45deg, #60a5fa, #a78bfa, #60a5fa) !important;
    background-position: left center;
    transition: 0.4s;
    background-size: 200% auto !important;
  }
  .dev .button-reverse:hover {
    background-position: right center !important;
  }
  .dev .shadow-3xl {
    box-shadow: 0 4px 8px 2px rgba(0, 5, 13, 0.5);
  }
  .dev body .scrollbar-none {
    scrollbar-width: none;
  }
  .dev body .scrollbar-none::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: 639px) {
    .dev .calc2rem {
      width: calc(100% - 2rem) !important;
    }
  }
  @media (min-width: 640px) {
    .dev .sm\:shadow-3xl {
      box-shadow: 0 4px 8px 2px rgba(0, 5, 13, 0.5);
    }
    .dev .calc4rem {
      width: calc(100% - 4rem) !important;
    }
  }
  @media (min-width: 768px) {
    .dev .md\:shadow-3xl {
      box-shadow: 0 4px 8px 2px rgba(0, 5, 13, 0.5);
    }
  }
  .dev .bg-first {
    /* background: #020420 !important; */
  }
  .dev .bg-linear {
    background: linear-gradient(45deg, #60a5fa, #a78bfa, #60a5fa);
    color: white;
  }
  .dev .bg-second {
    background: linear-gradient(-60deg, #f54f67, #ff8d9e, #f54f67);
    color: white;
  }
  .bg-third {
    background-color: rgb(255 255 255 / 5%);
  }
  .dev .v-tooltip > .v-overlay__content {
    background: linear-gradient(45deg, #60a5fa, #a78bfa, #60a5fa);
    box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.2);
  }
  .dev .v-skeleton-loader__image {
    height: 100%;
  }
  .dev .selected {
    background: rgba(255, 255, 255, 0.25) !important;
  }
  .dev .font-medium {
    font-weight: 600 !important;
  }
  .dev .v-img__placeholder .v-sheet {
    /* background: #020420; */
  }
  .dev .shadow-base {
    box-shadow: -5px -5px 5px -5px #008ca8, 5px 5px 5px -5px #008ca8, -7px -7px 10px -5px transparent,
      7px 7px 10px -5px transparent, 0 0 5px 0px rgba(255, 255, 255, 0), 0 55px 35px -20px rgba(0, 0, 0, 0.5);
    filter: drop-shadow(black 2px 4px 6px);
    padding: 3px 5px 0;
  }
  .dev .menu-anime {
    height: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 300ms;
    cursor: pointer;
    border-radius: 9999px;
    min-width: 46px;
    position: relative;
  }
  .dev .menu-anime:hover {
    scale: 1.05;
  }

  .dev .menu-anime .line1,
  .dev .menu-anime .line2 {
    width: 16px;
    height: 1.5px;
    position: absolute;
    background: white;
    border-radius: 9999px;
  }
  .dev .menu-anime .line2 {
    rotate: 90deg;
  }
  .dev .modal-menu-anime button.active {
    box-shadow: #fff 0 0 16px 0;
    outline: 1px solid;
  }
  .dev .progressbar {
    position: fixed;
    top: 0px;
    width: 100%;
    z-index: 10001;
  }

  .dev .progressbar .color {
    animation: ease 1.5s normal;
    border-radius: 100px;
    background: #008ca8;
    height: 3px;
    transition: all 1.5s, visibility 0s;
    width: 0;
    transition-timing-function: ease;
  }
  /* .v-text-field input,
  .v-btn__overlay,
  .v-text-field .v-field--single-line input {
    background: transparent;
  }
  .v-field--variant-filled:hover .v-field__overlay {
    opacity: 0;
  } */

  [data-vsbs-scroll] {
    padding: 0;
    height: 0;
    overflow-x: hidden;
  }
  [data-vsbs-scroll]::-webkit-scrollbar {
    width: 0px;
  }
  [data-vsbs-sheet] {
    background: linear-gradient(45deg, #2fddde 0%, #4f53af 30%, #344673 65%, #223255 100%);
    max-width: 100vw !important;
    z-index: 2000 !important;
    transition: height 0s, visibility 0.3s ease-in-out !important;
  }
  [data-vsbs-content] {
    max-width: 100vw;
    position: relative;
    height: calc(100% - 1px);
    padding: 0 !important;
    user-select: auto !important;
  }
  [data-vsbs-sheet-show="true"] {
    /* min-height: 100vh !important; */
    max-height: 100vh !important;
  }
  [data-vsbs-backdrop] {
    transition: 0.15s;
    opacity: 0;
  }
  .v-slider.v-input--horizontal .v-slider-track__tick {
    background: #c7cef8;
  }
  .v-overlay__scrim {
    /* opacity: 1 !important; */
    /* background: url(https://www.myutaku.com/images/mask.png);
    background-repeat: repeat; */
    /* background-color: rgb(0 0 0 / 25%); */
  }
  /* @supports (-webkit-touch-callout: none) {
    body {
      min-height: -webkit-fill-available;
    }
  } */
  .swiper-button-prev,
  .swiper-button-next {
    color: white;
    font-size: 5px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    box-shadow: 0 4px 8px 2px rgba(0, 5, 13, 0.5);
    background: linear-gradient(45deg, #60a5fa, #a78bfa, #60a5fa);
    transition: 0.3s;
  }
  .swiper-button-next:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(96, 165, 250, 0.5);
  }
  .swiper-button-prev::before,
  .swiper-button-next::before {
    content: "";
    position: absolute;
    inset: -3px;
    background: linear-gradient(45deg, #60a5fa, #a78bfa, #60a5fa);
    border-radius: 50%;
    z-index: -1;
    opacity: 0.5;
  }
  .swiper-button-prev::after,
  .swiper-button-next::after {
    font-size: 27px;
    font-weight: bold;
  }
  @media (max-width: 767px) {
    .swiper-button-prev,
    .swiper-button-next {
      display: none;
    }
  }
  .v-menu {
    z-index: 5000 !important;
  }
  .v-btn--variant-elevated,
  .v-btn--variant-flat {
    background: none;
  }
  .v-input--error:not(.v-input--disabled) .v-input__details > .v-icon,
  .v-input--error:not(.v-input--disabled) .v-input__details .v-messages,
  .v-input--error:not(.v-input--disabled) .v-input__prepend > .v-icon,
  .v-input--error:not(.v-input--disabled) .v-input__prepend .v-messages,
  .v-input--error:not(.v-input--disabled) .v-input__append > .v-icon,
  .v-input--error:not(.v-input--disabled) .v-input__append .v-messages,
  .v-field--error:not(.v-field--disabled) .v-field__prepend-inner > .v-icon,
  .v-field--error:not(.v-field--disabled) .v-field__append-inner > .v-icon,
  .v-field--error:not(.v-field--disabled) .v-field__clearable > .v-icon,
  .v-field--error:not(.v-field--disabled) .v-label.v-field-label {
    color: #f54f67;
  }
  .v-input__details {
    align-items: flex-start;
    padding-top: 4px;
  }
  .v-counter {
    color: white;
    margin-top: -2px;
  }
</style>
